<template>
  <div>
    <div class="dropdown-menu" :class="{show: $parent.openedDropdownMenu === 'controls'}">
      <h6 class="dropdown-header">{{ $t('UI_LIVE_MODE_TITLE') }}</h6>
      <!-- Init -->
      <a class="dropdown-item pointer" v-if="!$store.getters.instanceInLiveMode" @click="initLiveMode">
        {{ $t('UI_LIVE_MODE_INIT') }}
      </a>
      <!-- Play -->
      <a class="dropdown-item pointer" v-if="canStartTimer" @click="startTimer">
        <i class="fa fa-play"></i> {{ $t('UI_LIVE_MODE_START') }}
      </a>
      <!-- Pause -->
      <a class="dropdown-item pointer" v-if="liveModeRunning" @click="pauseTimer">
        <i class="fa fa-pause"></i> {{ $t('UI_LIVE_MODE_PAUSE') }}
      </a>
      <!-- Stop -->
      <a class="dropdown-item pointer" v-if="liveModeRunning" @click="stopTimer">
        <i class="fa fa-stop"></i> {{ $t('UI_LIVE_MODE_STOP') }}
      </a>
      <!-- Clear -->
      <a class="dropdown-item pointer" v-if="$store.getters.instanceInLiveMode" @click="clearLiveMode">
        <i class="fa fa-sign-out-alt"></i> {{ $t('UI_LIVE_MODE_CLEAR') }}
      </a>
      <div class="dropdown-divider" v-if="$store.getters.instanceInLiveMode"></div>
      <!-- Import Modal -->
      <a class="dropdown-item pointer" v-if="$store.getters.instanceInLiveMode"
         @click="$refs.importLastVideoModal.open()">
        <i class="fa fa-file-import"></i> {{ $t('UI_LIVE_MODE_IMPORT') }}
      </a>
    </div>

    <sweet-modal :title="$t('UI_LIVE_MODE_IMPORT')" ref="importLastVideoModal" class="text-left"
                 v-on:open="openImportVideoModal" :blocking="true" :pulse-on-block="false">
      <loading :active.sync="isLoading" :is-full-page="false"></loading>

      {{ $t('UI_LIVE_MODE_IMPORT_MODAL_TEXT') }}

      <v-select :label="$t('CHANNEL_SETTINGS_CATEGORY_SETTINGS_TITLE')"
                :options="importCategories"
                class="mt-2"
                label="name"
                :multiple="true"
                :searchable="true"
                :closeOnSelect="false"
                v-model="selectedCategories"
                :reduce="category => category.id"
                v-on:search:focus="expanded = true"
                v-on:search:blur="expanded = false"
                v-if="importCategories && !isLoading"></v-select>

      <div style="height: 330px;" v-if="expanded"></div>

      <div slot="button">
        <button class="btn btn-primary" @click="importVideo">
          {{ $t('UI_LIVE_MODE_IMPORT_BUTTON') }}
        </button>
        <button class="btn btn-secondary ml-1" @click="$refs.importLastVideoModal.close()">
          {{ $t('UI_MODAL_BUTTON_CLOSE') }}
        </button>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import { SweetModal } from 'sweet-modal-vue';
import { RepositoryFactory } from '../../../../repositories/RepositoryFactory';

const LiveModeRepository = RepositoryFactory.get('livemode');
const InstanceRepository = RepositoryFactory.get('instances');
const CategoryRepository = RepositoryFactory.get('categories');

	export default {
		name: 'LiveModeControls',
		components: {
			SweetModal,
			Loading
		},
		data() {
			return {
				importCategories: [],
				selectedCategories: [],
				isLoading: false,
				expanded: false
			};
		},
		computed: {
			liveModeRunning()  {
				if(this.$store.getters.instanceInLiveMode) {
					if(this.$store.getters.activeInstanceData.live !== undefined && this.$store.getters.activeInstanceData.live !== null) {
						return this.$store.getters.activeInstanceData.live.isRunning;
					}
				}
				return false;
			},
			canStartTimer() {
				if(this.$store.getters.instanceInLiveMode) {
					if(this.$store.getters.activeInstanceData.live === undefined)
						return false;

					return this.$store.getters.activeInstanceData.live.isRunning === false;
				}
				return false;
			}
		},
		methods: {
			initLiveMode() {
				// Switch to Livestream Sidepanel Tab
				LiveModeRepository.init();
			},
			startTimer() {
				LiveModeRepository.start();
			},
			pauseTimer() {
				LiveModeRepository.pause();
			},
			stopTimer() {
				LiveModeRepository.stop();
			},
			clearLiveMode() {
				LiveModeRepository.clear()
								.then(() => {
									this.$store.commit('setSelectedEntryId', null);
									this.$store.commit('setSelectedChapterId', null);
								});
			},
			openImportVideoModal() {
				this.isLoading = true;

				CategoryRepository.list()
								.then(res => {
									this.importCategories = res.data.list;
									this.checkDefaultCategories();
								})
								.catch(err => console.log(err))
								.finally(res => this.isLoading = false);
			},
			importVideo() {
				this.isLoading = true;
				LiveModeRepository.import(this.selectedCategories)
								.then(res => {
									this.$refs.importLastVideoModal.close();
								})
								.catch(err => {
									console.log(err);
								})
								.finally(res => {
									this.isLoading = false;
								});
			},
			checkDefaultCategories() {
				this.isLoading = true;
				this.selectedCategories = this.importCategories.filter(category => category.isChannelDefault)
								.map(category => category.id);
				this.isLoading = false;
			}
		}
	};
</script>

<style scoped>
  .fa {
    font-size: 12px;
  }
</style>
